import { useCallback } from "react";
import { useIntl } from "react-intl";
import DataExportListStore$ from "reports/data-export/data-export-list/stores/DataExportListStore";
import ReportsMessages from "reports/intl/ReportsMessages";

const useToggleStatus = ({ reportsList, postData, toastRef }) => {
  const { formatMessage } = useIntl();

  const toggleStatus = useCallback(
    (action) => {
      postData({ action, data: reportsList }).then((resp = []) => {
        if (resp.data?.length) {
          toastRef.current.show({
            detail: formatMessage(ReportsMessages.updateReportSuccessMessage),
            severity: "success",
            summary: formatMessage(ReportsMessages.toastSuccess),
          });

          DataExportListStore$.selection.set(null);
          DataExportListStore$.tableState.updatedEntities.set(resp.data);
        }
      });
    },
    [formatMessage, reportsList, postData, toastRef]
  );

  return toggleStatus;
};

export default useToggleStatus;
